import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDoorHanger: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="door-hanger, sign, do-not-disdurb"><path d="M5.75 7.91489V8.93989H8.875V7.91489C8.875 6.21662 10.2741 4.83989 12 4.83989C13.7259 4.83989 15.125 6.21662 15.125 7.91489V8.03478C15.125 9.79954 13.9774 11.3663 12.276 11.9244L8.59905 13.1304C6.89763 13.6885 5.75 15.2552 5.75 17.02V22.2649H18.25V7.91489C18.25 4.51834 15.4518 1.76489 12 1.76489C8.54822 1.76489 5.75 4.51834 5.75 7.91489Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconDoorHanger;
